<section class="md:h-screen py-36 flex items-center bg-neutral-900 bg-no-repeat bg-center">
  <div class="absolute inset-0 bg-gradient-to-b from-transparent to-black"></div>
  <div class="container">
    <div class="flex justify-center">
      <div class="max-w-[400px] w-full m-auto p-6 bg-white dark:bg-neutral-900 shadow-md dark:shadow-neutral-900 rounded-md">
        <a [routerLink]="'/'">
          <img [src]="'assets/images/logo-dark.png'" class="mx-auto h-7 block dark:hidden" alt="">
          <img [src]="'assets/images/logo-light.png'" class="mx-auto h-7 dark:block hidden" alt="">
        </a>
        <h5 class="my-6 text-xl font-semibold">{{ 'PASSWORD.FORGOT_PASSWORD_TITLE' | translate }}</h5>

        <!-- Error message display -->
        @if (errorMessage) {
          <div class="my-4 p-3 bg-red-100 text-red-700 rounded-md">
            {{ errorMessage }}
          </div>
        }

        <!-- Success message display -->
        @if (successMessage) {
          <div class="my-4 p-3 bg-green-100 text-green-700 rounded-md">
            {{ successMessage }}
          </div>
        }

        <div class="grid grid-cols-1">
          <p class="mb-6">{{ 'PASSWORD.FORGOT_PASSWORD_DESC' | translate }}</p>
          <form [formGroup]="forgotPasswordForm" (ngSubmit)="onSubmit()" class="text-start">
            <div class="grid grid-cols-1">
              <div class="mb-4">
                <label class="font-semibold" for="email">{{ 'PASSWORD.EMAIL' | translate }}:</label>
                <input id="email" type="email" formControlName="email" class="form-input w-full text-[15px] py-2 px-3 h-10 bg-transparent dark:bg-neutral-900 dark:text-neutral-200 rounded-full outline-none border border-gray-200 focus:border-neutral-600 dark:border-neutral-900 dark:focus:border-neutral-600 focus:ring-0 mt-3" placeholder="name@example.com">
                @if (forgotPasswordForm.get('email')?.invalid && forgotPasswordForm.get('email')?.touched) {
                  <div class="text-red-500 text-sm mt-1">
                    {{ 'PASSWORD.INVALID_EMAIL' | translate }}
                  </div>
                }
              </div>

              <div class="mb-4">
                <app-button [disabled]="forgotPasswordForm.invalid" [loading]="isLoading" color="primary" rounded="full" [fullWidth]="true" [type]="'submit'">
                  {{ 'PASSWORD.SEND_CODE_BTN' | translate }}
                </app-button>
              </div>

              <div class="text-center">
                <span class="me-2">{{ 'PASSWORD.REMEMBER_PASSWORD' | translate }} </span><a [routerLink]="'/login'" class="text-black dark:text-white font-bold">{{ 'PASSWORD.SIGN_IN' | translate }}</a>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
</section>
